/**
 * Musu Preloader v7.3
 * No per-char animation, static gradient on tagline.
 */

const initPreloader = () => {
    if (window.__preloaderSkipped) { document.body.classList.remove('is-loading'); var pl = document.getElementById('theme-preloader'); if (pl) pl.style.display = 'none'; return; }
    const preloader = document.getElementById('theme-preloader');
    if (!preloader) { document.body.classList.remove('is-loading'); return; }

    const counter = preloader.querySelector('.theme-preloader__counter');
    const counterWrapper = preloader.querySelector('.theme-preloader__counter-wrapper');
    const branding = preloader.querySelector('.theme-preloader__branding');
    const tagline = document.getElementById('preloader-tagline');
    const shutterTop = preloader.querySelector('.theme-preloader__shutter.context-top');
    const shutterBottom = preloader.querySelector('.theme-preloader__shutter.context-bottom');
    const grain = preloader.querySelector('.theme-preloader__grain');

    if (typeof gsap === 'undefined') {
        preloader.style.display = 'none';
        document.body.classList.remove('is-loading');
        return;
    }

    gsap.killTweensOf([counterWrapper, branding, shutterTop, shutterBottom, grain]);

    // Smooth counter 0-100
    let startTime = null;
    const counterDuration = 800;

    function animateCounter(timestamp) {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / counterDuration, 1);
        const eased = progress * progress * (3 - 2 * progress);
        if (counter) counter.textContent = Math.round(eased * 100);

        if (progress < 1) {
            requestAnimationFrame(animateCounter);
        } else {
            // Swap counter → logo
            gsap.to(counterWrapper, {
                opacity: 0,
                duration: 0.25,
                ease: "power2.out",
                onComplete: () => {
                    gsap.to(branding, {
                        opacity: 1,
                        duration: 0.35,
                        ease: "power2.out"
                    });
                }
            });
        }
    }
    requestAnimationFrame(animateCounter);

    // Split exit — enchaîné après le compteur (1100ms) + swap logo (250+350ms) + pause lecture logo
    const EXIT_AT = 800 + 250 + 350 + 700; // ~2,1s // ~2.4s après le début

    {
        setTimeout(() => {
            // Fade tagline
            gsap.to(tagline, {
                opacity: 0,
                duration: 0.4,
                ease: "power2.out"
            });

            // Top shutter + logo UP
            gsap.to(shutterTop, {
                yPercent: -100,
                duration: 1.2,
                ease: "power3.inOut",
                force3D: true
            });
            gsap.to(branding, {
                y: "-55vh",
                duration: 1.2,
                ease: "power3.inOut",
                force3D: true
            });

            // Bottom shutter DOWN
            gsap.to(shutterBottom, {
                yPercent: 100,
                duration: 1.2,
                ease: "power3.inOut",
                force3D: true
            });

            gsap.to(grain, {
                opacity: 0,
                duration: 0.6,
                delay: 0.2
            });

            gsap.delayedCall(1.3, () => {
                preloader.style.display = 'none';
                document.body.classList.remove('is-loading');
            });
        }, EXIT_AT);
    }

    // Safety
    setTimeout(() => {
        if (preloader.style.display !== 'none') {
            document.body.classList.remove('is-loading');
            preloader.style.display = 'none';
        }
    }, 5000);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreloader);
} else {
    initPreloader();
}
